import { PHONE_SIGN_IN_PATH } from "../constants/telephony";

// Where in the portal the agent was when they left for the phone sign-in.
export const PHONE_SIGN_IN_RETURN_KEY = "placetelPhoneSignIn.return";

/** Saves the page the agent is on, so the return from the phone sign-in lands there. */
export const rememberPhoneSignInReturn = (): void =>
  sessionStorage.setItem(PHONE_SIGN_IN_RETURN_KEY, window.location.hash || "#/");

export const phoneSignInRedirectUri = (): string => `${window.location.origin}${PHONE_SIGN_IN_PATH}`;

export const isPhoneSignInCallback = (): boolean => window.location.pathname === PHONE_SIGN_IN_PATH;

/**
 * Takes the query string the phone sign-in returned with and resets the
 * address bar to the portal root, so the code never stays in it. The portal
 * uses a hash router that history.replaceState does not notify, so the caller
 * navigates to returnPath, the page the agent left. Null when this is not the
 * return. The backend binds the sign-in state to the signed-in user, so only
 * the page to return to is kept here.
 */
export const takePhoneSignInCallback = (): { query: string; returnPath: string } | null => {
  if (!isPhoneSignInCallback()) return null;

  const query = window.location.search;
  const returnHash = sessionStorage.getItem(PHONE_SIGN_IN_RETURN_KEY) ?? "";
  sessionStorage.removeItem(PHONE_SIGN_IN_RETURN_KEY);
  // The code and state must not stay in the address bar or the history.
  window.history.replaceState(window.history.state, "", "/#/");
  return { query, returnPath: returnHash.startsWith("#/") ? returnHash.slice(1) : "/" };
};
